import commonGetters from '@/store/data/common/getters'
import { flattenDeep, includes, isEmpty, isNil, toLower, toString, deburr } from 'lodash'

const getters = {
    getItemById: (state, getters) => params => {
        let res = {}
        const _list = params.list ? params.list : state.hierarchies[state.selectedTaxoId]
        if (!isEmpty(_list)) {
            for (const node of _list) {
                if (!isEmpty(res)) {
                    break
                }
                if ((!isNil(node.id) && node.id === params.id) || (isNil(node.id) && node.key === params.id)) {
                    res = node
                } else if (node.id !== params.id && node.key !== params.id) {
                    if (!isEmpty(node.children)) {
                        res = getters.getItemById({
                            list: node.children,
                            id: params.id
                        })
                    }
                }
            }
        }
        return res
    },

    getTaxoSearchResults: (state, getters, rootState, rootGetters) => params => {
        const searchPattern = params.searchPattern
        let results = {}

        if (!isEmpty(searchPattern)) {
            const dataList = params.list ? params.list : state.hierarchies[state.selectedTaxoId]
            const resultId = []
            const resultLabel = []
            const resultCategory = []

            //Search Id
            if (params.type === 'id') {
                for (const elem of dataList) {
                    if (includes(toString(elem.id), searchPattern)) {
                        resultId.push(elem)
                    }
                    if (!isEmpty(elem.children)) {
                        const _children = getters.getTaxoSearchResults({ searchPattern, type: params.type, list: elem.children })
                        if (!isEmpty(_children)) {
                            resultId.push(..._children)
                        }
                    }
                }
            }

            if (params.type === 'label') {
                for (const elem of dataList) {
                    if (includes(toLower(deburr(elem.label)), toLower(deburr(searchPattern)))) {
                        resultLabel.push(elem)
                    }
                    if (!isEmpty(elem.children)) {
                        const _children = getters.getTaxoSearchResults({ searchPattern, type: params.type, list: elem.children })
                        if (!isEmpty(_children)) {
                            resultLabel.push(..._children)
                        }
                    }
                }
            }

            if (params.type === 'category') {
                for (const elem of dataList) {
                    if (includes(toLower(deburr(elem.category)), toLower(deburr(searchPattern)))) {
                        resultCategory.push(elem)
                    }
                    if (!isEmpty(elem.children)) {
                        const _children = getters.getTaxoSearchResults({ searchPattern, type: params.type, list: elem.children })
                        if (!isEmpty(_children)) {
                            resultCategory.push(..._children)
                        }
                    }
                }
            }

            // Results
            const result = [].concat(flattenDeep(resultId), flattenDeep(resultLabel), flattenDeep(resultCategory))

            if (!isEmpty(result)) {
                if (params.list) {
                    results = result
                } else {
                    const _taxoLabel = rootGetters['data/customTaxonomies/getWamCustomTaxoLabelById']({ taxoId: state.selectedTaxoId })
                    results[_taxoLabel] = result.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true, numeric: true }))
                }
            }
        }
        return results
    },

    getNodeAncestorsIds: (_state, getters) => params => {
        const node = params.node
        const _ancestors = params.ancestors

        if (!isNil(node.parent_id)) {
            const parent = getters.getItemById({
                id: node.parent_id
            })
            _ancestors.unshift(parent.id)
            if (!isNil(parent.parent_id)) {
                getters.getNodeAncestorsIds({
                    node: parent,
                    ancestors: _ancestors
                })
            }
        }
        return _ancestors
    },

    getSmartSegmentCount: state => () => {
        let count = 0
        for (const hierarchy in state.hierarchies) {
            retrieveFromChildren(state.hierarchies[hierarchy])
        }
        function retrieveFromChildren(children) {
            for (const segment in children) {
                if (children[segment].smart_segments && children[segment].smart_segments.length > 0) {
                    count += children[segment].smart_segments.length
                }
                if (children[segment].children.length > 0) {
                    retrieveFromChildren(children[segment].children)
                }
            }
        }
        return count
    }
}

export default { ...commonGetters, ...getters }
